module.exports = __webpack_public_path__ + "img/imagen-air.07111969.png";